import { generateKeys } from '../utils';
const _hooks = {
    BEFORE_TRADE: {},
    AFTER_LOGIN: {},
    IMMEDIATE: {},
    BEFORE_DEPOSIT: {},
    BEFORE_WITHDRAW: {},
    AFTER_ACCOUNT_SWITCH: {},
    AFTER_PROFILE_UPDATED: {},
    DASHBOARD_OPEN_ACCOUNTS: {
        platform: 'WEB',
    },
    AP_TEST_SUBMITTED: {},
};
export const hooks = generateKeys(_hooks);
export var actions;
(function (actions) {
    actions[actions["ALERT"] = 0] = "ALERT";
    actions[actions["OPEN_SCREEN"] = 1] = "OPEN_SCREEN";
    actions[actions["CONTINUE"] = 2] = "CONTINUE";
    actions[actions["CTA"] = 3] = "CTA";
    actions[actions["CLEAR"] = 4] = "CLEAR";
    actions[actions["TOAST"] = 5] = "TOAST";
    actions[actions["SWITCH_ACCOUNT"] = 6] = "SWITCH_ACCOUNT";
    actions[actions["EXPRESS_KYC"] = 7] = "EXPRESS_KYC";
})(actions || (actions = {}));
export var ctaLevels;
(function (ctaLevels) {
    ctaLevels["NOTICE"] = "NOTICE";
    ctaLevels["WARNING"] = "WARNING";
    ctaLevels["ERROR"] = "ERROR";
})(ctaLevels || (ctaLevels = {}));
export var toastLevels;
(function (toastLevels) {
    toastLevels["DANGER"] = "DANGER";
    toastLevels["INFO"] = "INFO";
    toastLevels["SUCCESS"] = "SUCCESS";
    toastLevels["WARNING"] = "WARNING";
})(toastLevels || (toastLevels = {}));
export var screens;
(function (screens) {
    screens["SPANISH_ALERT"] = "SPANISH_ALERT";
    screens["AP_TEST"] = "AP_TEST";
    screens["DEPOSIT"] = "DEPOSIT";
    screens["DOCUMENT_UPLOAD"] = "DOCUMENT_UPLOAD";
    screens["PROFILE"] = "PROFILE";
    screens["ECONOMIC_PROFILE"] = "ECONOMIC_PROFILE";
    screens["WITHDRAW"] = "WITHDRAW";
    screens["SUPPORT"] = "SUPPORT";
    screens["MIFIR"] = "MIFIR";
    screens["NATIONAL_ID"] = "NATIONAL_ID";
    screens["VERIFICATION_PAGE"] = "VERIFICATION_PAGE";
    screens["DAY_OF_BIRTH"] = "DAY_OF_BIRTH";
    screens["ONBOARDING_WIZARD"] = "ONBOARDING_WIZARD";
})(screens || (screens = {}));
export var forexTradingPlatforms;
(function (forexTradingPlatforms) {
    forexTradingPlatforms["MT4"] = "MT4";
    forexTradingPlatforms["MT5"] = "MT5";
    forexTradingPlatforms["ANY"] = "ANY";
})(forexTradingPlatforms || (forexTradingPlatforms = {}));
export var serverTypes;
(function (serverTypes) {
    serverTypes["REAL"] = "REAL";
    serverTypes["DEMO"] = "DEMO";
    serverTypes["ANY"] = "ANY";
})(serverTypes || (serverTypes = {}));
